document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.getElementById('CartDrawer');
    const cartDrawerOverlay = document.querySelector('.cart-drawer__overlay');
    const cartDrawerClose = document.getElementById('CartDrawerClose');
    const cartToggle = document.querySelector('.header-cart');
    const mobileCartToggle = document.querySelector('.mobile-icons .header-cart');
    let swiperInstance = null;
    const progressBarFill = document.querySelector('.progress-bar-fill');
    const thresholdIndicator = document.querySelector('.threshold-indicator');
    const thresholdIndicatorEnd = document.querySelector('.threshold-indicator-end');

    let paypalButton = null; // To cache the PayPal button
    let paypalButtonParent = null; // To remember the PayPal button's parent

    // Cache the PayPal button element on page load
    const paypalButtonElement = document.querySelector('.additional-checkout-buttons');
    if (paypalButtonElement) {
        paypalButton = paypalButtonElement;
        paypalButtonParent = paypalButton.parentNode;
    }

    var freeStandardShippingThreshold = 60;
    var freeExpressShippingThreshold = 250;

    // Open Cart Drawer
    function openCartDrawer(event) {
        event.preventDefault();
        document.body.classList.add('cart-drawer--open');
        loadCartSection(); // Fetch data when the cart is opened
        updateFreeShippingBar(); // Update the free shipping bar on opening the drawer
    }

    // Close Cart Drawer
    function closeCartDrawer() {
        document.body.classList.remove('cart-drawer--open');
        // Destroy Swiper instance when closing the cart
        if (swiperInstance !== null) {
            swiperInstance.destroy(true, true); // Destroy swiper and cleanup
            swiperInstance = null; // Reset swiper instance
        }
        const productRecommendationsWrapperSlider = document.querySelector('.cart-drawer__items');
        if (productRecommendationsWrapperSlider) {
            productRecommendationsWrapperSlider.innerHTML = '';// Remove the recommendations container from the DOM
        }
    }
    // Load cart items using Section Render API
    function loadCartSection() {
        const request = new XMLHttpRequest();
        request.open('GET', '/?section_id=cart__main', true);

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                const parser = new DOMParser();
                const newDocument = parser.parseFromString(request.responseText, 'text/html');
                const cartContentElement = newDocument.querySelector('.cart__form');

                if (cartContentElement) {
                    const cartItemsContainer = document.getElementById('CartDrawerItems');
                    cartItemsContainer.innerHTML = cartContentElement.innerHTML;
                    updateSummaryShippingMessage();
                    updateCartItemCount(); // Update the cart item count
                    loadRecommendations(); // Load recommendations each time cart is loaded
                    attachUpdateListeners(); // Attach quantity update and delete event listeners after content is loaded
                }
            } else {
                console.error('Error: Failed to fetch the cart section.');
            }
        };

        request.onerror = function () {
            console.error('Error: Network error occurred during the request.');
        };

        request.send();
    }
    function updateSummaryShippingMessage() {
        var shippingContainer = document.querySelector('.cart__shipping-container');
        var shippingText = document.querySelector('.cart__shipping');
        var freeShippingBar = document.querySelector('.free-shipping-bar');
        if (shippingContainer) {
            if (freeShippingBar.classList.contains('free-express-shipping-unlocked')) {
                shippingContainer.style.display = 'flex';
                shippingText.textContent = 'Free Express Shipping';
            } else if (freeShippingBar.classList.contains('free-standard-shipping-unlocked')) {
                shippingContainer.style.display = 'flex';
                shippingText.textContent = 'Free Shipping';
            } else {
                shippingContainer.style.display = 'none';
                shippingText.textContent = '';
            }
        }
    }
    function updateCartItemCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartItemCount = cart.item_count; // Get the total item count
                const cartItemCountElement = document.getElementById('cart-item-count');
                const headerCartCount = document.querySelectorAll('.header-cart__count--badge');
                const headerCartCountElement = document.getElementById('header-cart-count');
                
                if (headerCartCount.length > 0) {
                    headerCartCount.forEach(element => {
                        element.textContent = cartItemCount; // Update the header cart count
                    });
                }

                if (headerCartCountElement) {
                    headerCartCountElement.textContent = cartItemCount; // Reload the span element
                }

                if (cartItemCountElement) {
                    cartItemCountElement.textContent = `(${cartItemCount})`; // Update the cart item count
                }
                toggleCartItemsVisibility(cart);
            })
            .catch(error => console.error('Error fetching cart item count:', error));
    }

    // Load product recommendations dynamically and initialize Swiper
    function loadRecommendations() {
        const productRecommendationsWrapper = document.querySelector('.product-recommendations-container');
        if (productRecommendationsWrapper) {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    if (cart.items.length > 0) {
                        // Create a list of promises to fetch recommendations for each product in the cart
                        const recommendationPromises = [cart.items[0]].map(item => {
                            const productId = item.product_id;
                            return fetch(`${window.Shopify.routes.root}recommendations/products?product_id=${productId}&limit=4&section_id=product-recommendations&intent=related`)
                                .then(response => response.text());
                        });

                        // Wait for all recommendation fetches to complete
                        Promise.all(recommendationPromises).then(responses => {
                            let recommendationsFound = false;
                            let allRecommendationsHTML = '';

                            // Loop through all the responses
                            responses.forEach((text, index) => {
                                const parser = new DOMParser();
                                const doc = parser.parseFromString(text, "text/html");
                                const recommendations = doc.querySelector('.product-recommendations');

                                // If recommendations are found, add them to the combined HTML
                                if (recommendations && recommendations.innerHTML.trim().length) {
                                    const accumulatedDoc = parser.parseFromString(allRecommendationsHTML, "text/html");

                                    if (accumulatedDoc.querySelector('ul')) {
                                        recommendations.querySelectorAll('ul li').forEach(li => {
                                            accumulatedDoc.querySelector('ul').appendChild(li);
                                        });
                                        allRecommendationsHTML = accumulatedDoc.body.innerHTML;
                                    } else {
                                        allRecommendationsHTML += recommendations.innerHTML;
                                    }
                                    recommendationsFound = true;
                                }
                            });

                            // Destroy existing Swiper instance if it exists
                            if (swiperInstance) {
                                swiperInstance.destroy(true, true);
                                swiperInstance = null;
                            }

                            if (recommendationsFound) {
                                // Set the recommendations HTML
                                productRecommendationsWrapper.innerHTML = allRecommendationsHTML;

                                // Add Swiper-specific classes dynamically
                                const productList = productRecommendationsWrapper.querySelector('ul');
                                const products = productList.querySelectorAll('li');
                                productList.classList.add('swiper-wrapper');
                                products.forEach(product => product.classList.add('swiper-slide'));

                                // Initialize Swiper if not already initialized
                                if (swiperInstance === null) {
                                    swiperInstance = new Swiper('.product-slider-section .swiper-container', {
                                        slidesPerView: "auto",
                                        pagination: {
                                            el: ".swiper-pagination",
                                            clickable: true,
                                        },
                                        loop: false, // Enables infinite loop sliding
                                    });
                                }
                            } else {
                                productRecommendationsWrapper.innerHTML = ''; // Clear recommendations if none are found
                            }
                        });
                    } else {
                        // Clear recommendations if the cart is empty
                        productRecommendationsWrapper.innerHTML = '';
                        if (swiperInstance) {
                            swiperInstance.destroy(true, true);
                            swiperInstance = null;
                        }
                    }
                });
        }
    }
    document.addEventListener('item:added', function (event) {
        openCartDrawer(event); // Optionally open the cart drawer
        updateFreeShippingBar();
    });

    // Update the free shipping bar
    function updateFreeShippingBar() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                var cartTotal = cart.total_price / 100; // Convert from cents to dollars
                var freeShippingBar = document.querySelector('.free-shipping-bar');
                freeShippingBar.style.display = ''; // Show the bar if cart is not empty

                var amountLeftForStandard = freeStandardShippingThreshold - cartTotal;
                var amountLeftForExpress = freeExpressShippingThreshold - cartTotal;
                var amountLeftText;
                if (cartTotal >= freeExpressShippingThreshold) {
                    amountLeftText = 'You have unlocked <span class="rs-border-0 rs-border-b rs-border-dark-blue" style="border-bottom-style: dashed;">Free Express Shipping!</span>';
                    freeShippingBar.classList.add('free-express-shipping-unlocked');
                    freeShippingBar.classList.remove('free-standard-shipping-unlocked');
                } else if (cartTotal >= freeStandardShippingThreshold) {
                    amountLeftText = `Add <strong class="rs-font-semibold">$${amountLeftForExpress.toFixed(2)}</strong> to unlock <span class="rs-border-0 rs-border-b rs-border-dark-blue" style="border-bottom-style: dashed;">Free Express Shipping!</span>`;
                    freeShippingBar.classList.add('free-standard-shipping-unlocked');
                    freeShippingBar.classList.remove('free-express-shipping-unlocked');
                } else {
                    amountLeftText = `Add <strong class="rs-font-semibold">$${amountLeftForStandard.toFixed(2)}</strong> to unlock <span class="rs-border-0 rs-border-b rs-border-dark-blue" style="border-bottom-style: dashed;">Free Shipping!</span>`;
                    freeShippingBar.classList.remove('free-standard-shipping-unlocked');
                    freeShippingBar.classList.remove('free-express-shipping-unlocked');
                }

                document.getElementById('amount-left').innerHTML = amountLeftText;

                var fillPercentage = Math.min((cartTotal / freeExpressShippingThreshold) * 100, 100);
                var freeStandardShipping = Math.min((freeStandardShippingThreshold / freeExpressShippingThreshold) * 100, 100);
                document.querySelector('.shipping-indication').style.left = `${freeStandardShipping}%`;
                document.querySelector('.progress-bar-fill').style.width = `${fillPercentage}%`;
                document.querySelector('.threshold-indicator-end').style.left = '100%';
                updateSummaryShippingMessage();
            })
            .catch(error => console.error('Error fetching cart:', error));
    }

    // Function to update the class based on the progress bar fill width
    function updateThresholdClasses() {
        const progressBarFillWidth = progressBarFill.offsetWidth;
        const progressBarFillParentWidth = progressBarFill.parentElement.offsetWidth;

        // Calculate the current width percentage of the progress bar fill
        const currentWidthPercentage = (progressBarFillWidth / progressBarFillParentWidth) * 100;

        // Get the left positions of the threshold indicators
        const thresholdLeft = parseFloat(thresholdIndicator.style.left);
        const thresholdEndLeft = parseFloat(thresholdIndicatorEnd.style.left);

        // Update the class for the first threshold
        if (currentWidthPercentage >= thresholdLeft) {
            thresholdIndicator.classList.add('crossed-threshold');
        } else {
            thresholdIndicator.classList.remove('crossed-threshold');
        }

        // Update the class for the end threshold
        if (currentWidthPercentage >= thresholdEndLeft) {
            thresholdIndicatorEnd.classList.add('crossed-threshold-end');
        } else {
            thresholdIndicatorEnd.classList.remove('crossed-threshold-end');
        }
    }

    // Call the update function initially
    updateThresholdClasses();

    const addToCartForms = document.querySelectorAll('form[action^="/cart/add"]');

    addToCartForms.forEach(form => {
        form.addEventListener('submit', function (event) {
            event.preventDefault(); // Prevent default form submission (which redirects to the cart)

            const formData = new FormData(form);
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest', // Ensure the request is recognized as AJAX
                },
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(cartItem => {
                    openCartDrawer(event); // Optionally open the cart drawer
                    updateCartItemCount(); // Update the cart item count
                    updateSummaryShippingMessage();
                    const headerCartCount = document.querySelector('.header-cart__count--badge');
                    const headerCartCountElement = document.getElementById('header-cart-count');

                    if (headerCartCount) {
                        headerCartCount.textContent = cartItemCount; // Update the header cart count
                    }

                    if (headerCartCountElement) {
                        headerCartCountElement.textContent = cartItemCount; // Reload the span element
                    }
                })
        });
    });

    function deleteCartItem(id) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                line: id,  // Use the line item key
                quantity: 0, // Set quantity to 0 to remove the item
            }),
        })
            .then(response => response.json())
            .then(cart => {
                updateFreeShippingBar();  // Update the free shipping progress bar
                loadCartSection();   // Re-fetch and re-render the cart drawer content
                updateSummaryShippingMessage();
            })
            .catch(error => {
                console.error("Error deleting cart item:", error);
            });
    }
    // Update the cart drawer and handle the PayPal button
    function updateCartDrawer(cart) {
        const paypalButton = document.querySelector('.additional-checkout-buttons'); // Adjust the selector for your PayPal button
        const paypalButtonParent = paypalButton ? paypalButton.parentNode : null;

        // Temporarily remove the PayPal button if it exists
        if (paypalButton && paypalButtonParent) {
            paypalButtonParent.removeChild(paypalButton);
        }

        // Update each cart item's total price
        cart.items.forEach(item => {
            const itemFinalLinePrice = (item.final_line_price / 100).toFixed(2);
            const productPriceElement = document.querySelector(`.cart__total[data-line-item-key="${item.key}"]`);
            const productCard = document.querySelector(`.cart__card[data-cart-item="${item.key}"]`);
            const quantityMinusElement = productCard.querySelector('.quantity-minus');
            if (productPriceElement) {
                productPriceElement.textContent = `$${itemFinalLinePrice}`;
            }
            if (item.quantity > 1) {
                quantityMinusElement.removeAttribute('disabled');
            } else {
                quantityMinusElement.setAttribute('disabled', true);
            }
        });

        // Update the cart subtotal
        const total = (cart.total_price / 100).toFixed(2);
        document.querySelector('.cart__subtotal').textContent = `$${total}`;

        // Reattach the PayPal button if it was removed
        if (paypalButton && paypalButtonParent) {
            paypalButtonParent.appendChild(paypalButton);
        }
        // If there are no items in the cart, you might want to hide or disable the PayPal button
        if (cart.item_count === 0 && paypalButton) {
            paypalButton.style.display = 'none'; // Hide it if cart is empty
        } else if (paypalButton) {
            paypalButton.style.display = ''; // Show it if cart is not empty
        }
        toggleCartItemsVisibility(cart);
    }
    function toggleCartItemsVisibility(cart) {
        const cartItemsContainer = document.querySelector('.cart-drawer__items');
        const cartEmptyContainer = document.querySelector('.cart-drawer__empty');
        const returnPolicy = document.getElementById('return-policy');
        if (cart.item_count === 0) {
            cartItemsContainer.style.display = 'none';
            cartEmptyContainer.style.display = 'block';
            if (returnPolicy) {
                returnPolicy.style.display = 'none';
            }
        } else {
            cartItemsContainer.style.display = 'block';
            cartEmptyContainer.style.display = 'none';
            if (returnPolicy) {
                returnPolicy.style.display = 'block';
            }
        }
    }
    // Disable cart interactions when updating
    function disableCartInteractions(disable) {
        const quantityInputs = document.querySelectorAll('.quantity-input');
        quantityInputs.forEach(input => { input.disabled = disable; });

        const buttons = document.querySelectorAll('.quantity-plus, .quantity-minus, .button_remove');
        buttons.forEach(button => { button.disabled = disable; });
    }

    // Function to handle cart updates
    function updateCartItem(id, quantity) {
        if (quantity <= 0) {
            console.error('Quantity must be a positive number');
            return;
        }

        disableCartInteractions(true);

        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: id, quantity }),
        })
            .then(response => response.json())
            .then(cart => {
                loadRecommendations();
                updateCartDrawer(cart);
                updateCartItemCount();
                updateSummaryShippingMessage();
                updateFreeShippingBar(cart);
            })
            .finally(() => {
                disableCartInteractions(false);
            });
    }

    // Create a MutationObserver to watch for changes in the style attribute
    const observer = new MutationObserver(updateThresholdClasses);

    // Observe changes to the attributes of the progressBarFill element
    observer.observe(progressBarFill, { attributes: true, attributeFilter: ['style'] });

    function attachUpdateListeners() {
        const quantityInputs = document.querySelectorAll('.quantity-input');

        quantityInputs.forEach(input => {
            const cartItem = input.closest('.purchase-details__quantity');
            const itemId = cartItem.dataset.lineItemKey;

            input.addEventListener('change', function () {
                const newQuantity = parseInt(input.value, 10);
                if (newQuantity > 0) {

                    updateCartItem(itemId, newQuantity);
                } else {
                    console.error('Quantity must be a positive number.');
                }
            });

            const plusButton = cartItem.querySelector('.quantity-plus');
            const minusButton = cartItem.querySelector('.quantity-minus');

            if (plusButton) {
                plusButton.addEventListener('click', function () {
                    const currentQuantity = parseInt(input.value, 10);
                    const newQuantity = currentQuantity + 1;
                    input.value = newQuantity;

                    updateCartItem(itemId, newQuantity);
                });
            }

            if (minusButton) {
                minusButton.addEventListener('click', function () {
                    const currentQuantity = parseInt(input.value, 10);
                    if (currentQuantity > 1) {
                        const newQuantity = currentQuantity - 1;
                        input.value = newQuantity;

                        updateCartItem(itemId, newQuantity);
                    }
                });
            }
        });
        document.querySelectorAll('.cart__remove-btn').forEach(button => {
            button.addEventListener('click', function (event) {
                event.preventDefault(); // Prevent the default link behavior
                // Get the parent element
                const parentCartRemove = this.closest('.cart__remove');
                // Check if the parent element exists
                if (parentCartRemove) {
                    // Get the data attributes or perform your delete logic here
                    // const itemId = this.getAttribute('data-cart-item-key');
                    const itemId = this.getAttribute('data-line-item-key');

                    // Call a function to handle the deletion (you'll need to implement this function)
                    deleteCartItem(itemId);
                }
            });
        });
    }
    if (cartToggle) {
        cartToggle.addEventListener('click', openCartDrawer);
    } else {
        console.error('Cart toggle element not found.');
    }
    if (mobileCartToggle) {
        mobileCartToggle.addEventListener('click', openCartDrawer);
    } else {
        console.error('Cart toggle element not found.');
    }
    // Close drawer with close button or overlay click
    cartDrawerClose.addEventListener('click', closeCartDrawer);
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
});